<template>
  <div>
    <v-row no-gutters>
      <field-label :field="field"></field-label>
    </v-row>

    <v-row>
      <v-col class="pt-0 pb-0" cols="3">
        <v-text-field
          class="pt-0 mt-0"
          :value="value"
          outlined
          dense
          @input="input"
          :rules="rules"
          disabled
        ></v-text-field>
      </v-col>
      <v-col class="pt-0 pb-0" cols="9">
        <v-slider
          class="pt-1 mt-0"
          :value="sliderValue"
          :min="field.min"
          :max="field.max"
          :step="field.step || 1"
          @input="input"
          :disabled="field.disabled"
        ></v-slider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import FieldLabel from '@/components/editor/partials/FieldLabel'

export default {
  name: 'SliderField',
  props: ['value', 'field'],
  components: {
    FieldLabel
  },
  computed: {
    sliderValue() {
      let value = this.value || this.field.min || 0

      if (this.field.suffix) {
        value = value.toString().replace(this.field.suffix, '')
      }

      return value
    },
    rules() {
      let rules = this.field.rules || []

      return rules.map(rule => this.$store.state.editor.validation.rules[rule])
    }
  },
  methods: {
    input(value) {
      if (this.field.suffix) {
        value += this.field.suffix
      }

      this.$emit('update:value', value.toString())
    },
    setDefaultValue() {
      // TODO - fix default value set up
      // if (this.value === undefined & this.field.default !== undefined) {
      //   let value = this.field.default
      //   if (this.field.suffix) {
      //     value = value.toString().replace(this.field.suffix, '')
      //   }
      //   this.input(value)
      // }
    }
  },
  mounted() {
    this.setDefaultValue()
  }
}
</script>
